var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.componentType && _vm.componentType.view)?_c(_vm.componentType.view,_vm._b({ref:"component",tag:"component",on:{"setParams":_vm.setParams}},'component',_vm.componentProps,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }